import { START_YEAR } from '../constants/generationControlConstants';

/**
 * Transforma los datos de control de generación para su visualización en la tabla
 * @param {Array} generateControls - Array de controles desde la API
 * @returns {Array} - Array de controles transformados
 */
export const transformGenerationControlData = (generateControls) => {
  return generateControls.map((generateControl) => ({
    toGenerate: generateControl.to_generate,
    generated: generateControl.generated,
    notGenerated: generateControl.not_generated,
    ordersNotGenerated: generateControl.orders_not_generated,
    month: generateControl.month,
    year: generateControl.year,
  }));
};

/**
 * Genera elementos de menú para años
 * @param {number} startYear - Año inicial (opcional, por defecto 1990)
 * @returns {Array} - Array de elementos para select
 */
export const generateYearOptions = (startYear = START_YEAR) => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }
  return years;
};

/**
 * Valida si hay órdenes no generadas para mostrar
 * @param {Array} ordersNotGenerated - Array de órdenes no generadas
 * @returns {boolean} - True si hay órdenes para mostrar
 */
export const hasOrdersNotGenerated = (ordersNotGenerated) => {
  return Array.isArray(ordersNotGenerated) && ordersNotGenerated.length > 0;
};

/**
 * Limpia filtros vacíos antes de enviar a la API
 * @param {Object} filters - Filtros del formulario
 * @returns {Object} - Filtros limpiados
 */
export const cleanFilters = (filters) => {
  const cleanedFilters = { ...filters };

  Object.keys(cleanedFilters).forEach((key) => {
    if (cleanedFilters[key] === '' || cleanedFilters[key] === null) {
      delete cleanedFilters[key];
    }
  });

  return cleanedFilters;
};
